import React, { useState, useRef } from 'react'
import { connect } from 'react-redux'
import cn from 'classnames'

import ToggleSwitch from '../ToggleButton'
import Toggle from '../Toggle'
import QuickMenuSearch from '../../containers/QuickMenuSearch'
import { ReactComponent as SearchIcon } from '../../assets/icons/tabs/magnify-glass.svg'
import { ReactComponent as SyncIcon } from '../../assets/icons/sync.svg'
import { ReactComponent as LoadingIcon } from '../../assets/icons/tabs/authorizing-icon.svg'
import { ReactComponent as HamburgerReport } from '../../assets/icons/summary-report.svg'
import Button from '../../components/Button'

import styles from './OrderListControlBar.module.scss'

const OrderListControlBar = ({ searchData, isSuites, clearSearch, showClosedTabs, showOnlyActiveAttendantOrders, toggleShowClosedTabs, setShowOnlyActiveAttendantOrders, unsyncedRemoteIds, unsyncedLocalIds, preOrdersAreLoading, reloadPreorders, showAttendantSummary, className }) => {
  const classNames = cn(styles.OrderListControlBar, className)
  const [quickSearchFlag, setQuickSearchFlag] = useState(false)
  const quickSearchRef = useRef()

  const mediaQuery = window.matchMedia("(min-width: 800px)")

  const searchControl = (enableSearch) => {
    if (!enableSearch) {
      clearSearch()
    }
    setQuickSearchFlag(enableSearch)
  }

  const quickMenuSearch = quickSearchFlag ? <QuickMenuSearch searchItems={searchData} setQuickSearchFlag={setQuickSearchFlag} quickSearchRef={quickSearchRef} /> : null
  let infoStatement

  if (isSuites) {
    if (preOrdersAreLoading) {
      infoStatement = <div className={styles.loading}>Orders are refreshing, you may see missing information.</div>;
    } else if (unsyncedRemoteIds.length > 0) {
      infoStatement = <div className={styles.loading}>{unsyncedRemoteIds.length} orders have been updated remotely.</div>;
    } else if (unsyncedLocalIds.length > 0) {
      infoStatement = <div className={styles.loading}>{unsyncedLocalIds.length} unsynced locally.</div>;
    }
  } else if (mediaQuery.matches) {
    infoStatement = <Button className={styles.syncButton} onClick={reloadPreorders}>Sync Orders</Button>
  } 

  return (
    <div className={classNames}>
      <div className={styles.loading}>
      <div onClick={showAttendantSummary} className={styles.showAttendantSummary}><HamburgerReport /></div>
      <Toggle 
        selectionTextOne={"My Orders"} 
        selectionTextTwo={"All Orders"} 
        selected={showOnlyActiveAttendantOrders} 
        onChange={() => setShowOnlyActiveAttendantOrders(!showOnlyActiveAttendantOrders)}
      />
      </div>
      <div className={styles.controlButtons}>
        <div className={styles.showClosedTabsToggle}>
          <div className={styles.toggleText}>
            Show Closed
          </div>
          <ToggleSwitch checked={showClosedTabs} onChange={toggleShowClosedTabs} />
        </div>
        <div className={styles.syncOrderIcon}>
          {preOrdersAreLoading ? <LoadingIcon /> : <SyncIcon onClick={reloadPreorders}/>}
        </div>
      </div>
      <div className={styles.addAndSearch}>
        <div className={styles.search} onClick={() => searchControl(!quickSearchFlag)}>
          <SearchIcon />
        </div>
      </div>
      {quickMenuSearch}
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    unsyncedLocalIds: state.order?.unsyncedLocalIds ?? [],
    unsyncedRemoteIds: state.order?.unsyncedRemoteIds ?? [],
    preOrdersAreLoading: state.order.preOrdersAreLoading
  }
}

export default connect(mapStateToProps, null)(OrderListControlBar)
